import {
    FETCH_WORKERS,
    ADD_WORKER_TO_COMPANY,
    REMOVE_WORKER_FROM_COMPANY,
    LOCK_WORKER_BUDGET,
    FETCH_WORKER_PERMISSIONS,
    GRANT_PAYMENT_PERMISSION,
    REVOKE_PAYMENT_PERMISSION
} from '../types';
import api from '../api';

export const fetchWorkers = (companyId) => {
    return {
        type: FETCH_WORKERS,
        payload: api.company.get(companyId).workers.getAll(),
    };
};

export const addWorkerToCompany = (companyId, worker) => {
    return {
        type: ADD_WORKER_TO_COMPANY,
        payload: api.company.get(companyId).workers.addWorker(worker)
    };
};

export const removeWorker = (companyId, methodId) => {
    return {
        type: REMOVE_WORKER_FROM_COMPANY,
        payload: api.company.get(companyId).workers.revokeWorker({ methodId }),
    };
};

export const lockBudgetMethod = (companyId, methodId, lock) => {
    return {
        type: LOCK_WORKER_BUDGET,
        payload: api.company.get(companyId).workers.lockWorker({ methodId, lock }),
    };
};

export const fetchWorkerPermissions = (companyId, workerId) => {
    return {
        type: FETCH_WORKER_PERMISSIONS,
        payload: api.company.get(companyId).workers.get(workerId).permissions.getAll(),
        meta: { id: workerId }
    };
};

export const grantPaymentPermissions = (companyId, workerId, permission) => {
    return {
        type: GRANT_PAYMENT_PERMISSION,
        payload: api.company.get(companyId).workers.get(workerId).permissions.create(permission),
        meta: { id: workerId }
    };
};

export const deletePaymentPermissions = (companyId, workerId, permissionId) => {
    return {
        type: REVOKE_PAYMENT_PERMISSION,
        payload: api.company.get(companyId).workers.get(workerId).permissions.delete(permissionId),
        meta: { id: workerId }
    };
};
